import {
  BankOutlined,
  DeleteOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../../constants'
import validator from '../../../validator'
import {
  CreateSubTaskUploadFileListItemStyled,
  CreateSubTaskUploadFileListWrapperStyled,
} from './WorkDetailV2Styled'
import moment from 'moment'
import {
  SelectList,
  SelectTitle,
} from '../../MissionCreatePage/MissionCreatePageStyled'
import { blue, yellowPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'

const WorkDetailUpdateModal = props => {
  const {
    fileStore,
    workStore,
    loadingAnimationStore,
    selectPeopleStore,
    isOpenModal,
    setIsOpenModal,
    infoOptionStore,
    aclStore,
  } = props

  const { workDetail } = workStore || {}

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const { setFieldsValue } = form
  const EDITOR_REF = useRef()

  const [fileUploadedList, setFileUploadedList] = useState([])
  const [fileList, setFileList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [disableList, setDisableList] = useState([])

  const userList = workDetail?.assignees
    ? workDetail?.assignees.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []

  const departmentList = workDetail?.assignees
    ? workDetail?.assignees.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
      )
    : []

  const groupList = workDetail?.assignees
    ? workDetail?.assignees.filter(
        el => el.assignee_type === ASSIGNEE_TYPE.GROUP
      )
    : []

  useEffect(() => {
    ;(async () => {
      const disableInfo = await infoOptionStore.load('WORK_SELECT_DISABLE')
      let disables = disableInfo?.split(',') || []
      const isAllowIgnore = await aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.select_executive_board__WORK
      )
      if (disables?.length > 0 && !isAllowIgnore) {
        setDisableList(disables)
      } else {
        setDisableList([])
      }
    })()
  }, [])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (!isOpenModal) return

    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupList)
      )
    }
  }, [isOpenModal, originDepartmentWithUserList])

  useEffect(() => {
    if (!isOpenModal) return
    setFieldsValue({
      title: workDetail?.title,
      start_date: workDetail?.start_date && moment(workDetail?.start_date),
      due_date: workDetail?.due_date && moment(workDetail?.due_date),
    })
    setFileUploadedList(workDetail?.attachments)
  }, [isOpenModal, workDetail, setFieldsValue])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const onFinish = async value => {
    try {
      loadingAnimationStore.showSpinner(true)
      const code_work = workDetail?.code
      const new_items_assign = []
      const remove_items_assign = []
      const listAssignOrigin = [
        ...userList,
        ...departmentList,
        ...groupList,
      ].map(el => ({
        assignee_code: el.assignee_code,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))
      const listAssignAfter = [...followerList, ...handlerList].map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))
      if (handlerList.length === 0) {
        return isElectronicWork
          ? message.info('Bạn chưa chọn lãnh đạo ký duyệt!')
          : message.info('Bạn chưa chọn người xử lý!')
      }
      listAssignAfter.forEach(assignAfter => {
        if (
          !listAssignOrigin.some(
            assignOrigin =>
              assignOrigin.assignee_code + assignOrigin.permission ===
              assignAfter.assignee_code + assignAfter.permission
          )
        ) {
          new_items_assign.push({
            assignee_code: assignAfter.assignee_code,
            assignee_type: assignAfter.assignee_type,
            permission: assignAfter.permission,
          })
        }
      })
      listAssignOrigin.forEach(assignOrigin => {
        if (
          !listAssignAfter.some(
            assignAfter =>
              assignAfter.assignee_code + assignAfter.permission ===
              assignOrigin.assignee_code + assignOrigin.permission
          )
        ) {
          remove_items_assign.push({
            assignee_code: assignOrigin.assignee_code,
            assignee_type: assignOrigin.assignee_type,
            permission: assignOrigin.permission,
          })
        }
      })

      const { title, start_date, due_date } = value
      const uploadFileList = fileList.map(file => file.originFileObj)
      const batchUploadArr = []
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })
      const response = await Promise.all(batchUploadArr)
      const dataSubmit = {
        title: title,
        start_date: start_date,
        due_date: due_date,
        content: EDITOR_REF?.current?.editor?.getData(),
        attachments: response
          .map(response => response.data.file_id)
          .concat(fileUploadedList.map(file => file.file_id)),
        assignees: {
          new_items: new_items_assign,
          remove_items: remove_items_assign,
        },
        current_assignees: listAssignAfter,
        code: code_work,
        work_type: workDetail?.work_type,
      }
      await workStore.updateWork(code_work, dataSubmit)
      await workStore.getWorkDetail(code_work)

      handleCancel()
      message.success('Cập nhật công việc thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handleCancel = () => {
    selectPeopleStore.clearSelected()
    form.resetFields()
    setFileList([])
    setHandlerList([])
    setFollowerList([])
    setIsOpenModal(false)
  }
  const isElectronicWork = workDetail?.work_type === WORK_STATUS.ELECTRONIC

  return (
    <Modal
      width={800}
      style={{ top: 40, zIndex: 500 }}
      wrapClassName="custom-modal-wrapper"
      title={'Chỉnh sửa công việc'}
      open={isOpenModal}
      maskClosable={false}
      onCancel={() => {
        handleCancel()
      }}
      footer={null}
      destroyOnClose>
      <div>
        <Form onFinish={onFinish} form={form} layout="vertical">
          <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
            Thông tin chung
          </h3>

          <Form.Item
            label={'Tiêu đề:'}
            name={'title'}
            rules={[
              { required: true, message: 'Vui lòng nhập tiêu đề' },
              {
                max: 499,
                message: 'Tiêu đề đã đủ 500 ký tự, không thể nhập thêm!',
              },
              { validator: validator.validateInputString },
            ]}>
            <Input
              maxLength={500}
              placeholder={'Nhập tiêu đề...'}
              className="h-40"
              disabled={isElectronicWork}
            />
          </Form.Item>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label={'Ngày bắt đầu:'}
                rules={[
                  { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
                ]}
                name={'start_date'}>
                <DatePicker
                  format={DATE_FORMAT_LIST}
                  className="h-40"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={'Ngày kết thúc:'}
                name={'due_date'}
                rules={[
                  { required: false, message: 'Vui lòng chọn ngày kết thúc!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startDate = getFieldValue('start_date')
                      if (!startDate || !value) {
                        //! Không thực hiện kiểm tra nếu ngày bắt đầu hoặc ngày kết thúc không có giá trị
                        return Promise.resolve()
                      }
                      if (value.isAfter(startDate)) {
                        //! Ngày kết thúc lớn hơn ngày bắt đầu
                        return Promise.resolve()
                      }
                      //! Ngày kết thúc không hợp lệ
                      return Promise.reject(
                        'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                      )
                    },
                  }),
                ]}>
                <DatePicker
                  format={DATE_FORMAT_LIST}
                  className="h-40"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <SelectTitle>
                <span>
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontFamily: 'SimSun, sans-serif',
                      marginRight: '-4px',
                    }}>
                    *{' '}
                  </span>
                  <span style={{ marginRight: '10px' }}>
                    {isElectronicWork ? 'Lãnh đạo ký duyệt:' : 'Người xử lý:'}
                  </span>
                </span>
                <Space>
                  <Tooltip title="Chọn người dùng" color={blue}>
                    <Button
                      className="select-user-icon-btn"
                      icon={<UserOutlined style={{ color: blue }} />}
                      onClick={() =>
                        handleOpenSelectUserDepartmentPopup(
                          ASSIGNEE_TYPE.HANDLER
                        )
                      }
                    />
                  </Tooltip>
                  {!isElectronicWork && (
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={() =>
                          handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                        }
                      />
                    </Tooltip>
                  )}
                </Space>
              </SelectTitle>
              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>

            <Col span={12}>
              <SelectTitle>
                <span>
                  <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
                </span>
                <Space>
                  <Tooltip title="Chọn người dùng" color={blue}>
                    <Button
                      className="select-user-icon-btn"
                      icon={<UserOutlined style={{ color: blue }} />}
                      onClick={() =>
                        handleOpenSelectUserDepartmentPopup(
                          ASSIGNEE_TYPE.FOLLOWER
                        )
                      }
                    />
                  </Tooltip>
                  <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                    <Button
                      className="select-user-icon-btn"
                      icon={<TeamOutlined />}
                      style={{ color: yellowPrimary }}
                      onClick={() =>
                        handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                      }
                    />
                  </Tooltip>
                </Space>
              </SelectTitle>
              <SelectList>
                {followerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>

            <Col span={24}>
              <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
                <Tabs.TabPane tab="Nội dung" key="1" forceRender>
                  <Form.Item label={'Nội dung:'} name={'content'}>
                    <RichEditor
                      EDITOR_REF={EDITOR_REF}
                      placeholder={'Nhập nội dung...'}
                      editorContent={workDetail?.content || ''}
                    />
                  </Form.Item>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Tài liệu đính kèm" key="2" forceRender>
                  <Form.Item
                    label={'Tài liệu đính kèm:'}
                    name={'id_file_dinh_kem'}>
                    <Upload.Dragger
                      valuePropName={'fileList'}
                      fileList={fileList}
                      multiple={true}
                      onChange={handleChangeFile}
                      beforeUpload={() => false}
                      showUploadList={false}
                      className="custom-dragger-upload">
                      <DraggerUploadButton />
                    </Upload.Dragger>
                  </Form.Item>
                  {fileList.length !== 0 && (
                    <CreateSubTaskUploadFileListWrapperStyled>
                      {fileList.map(file => (
                        <CreateSubTaskUploadFileListItemStyled key={file.uid}>
                          <FileTextOutlined />
                          <span className="file-name">{file.name}</span>
                          <Tooltip title={'Xoá tập tin'}>
                            <DeleteOutlined
                              onClick={() =>
                                handleRemoveFileFromUploadList(file.uid)
                              }
                            />
                          </Tooltip>
                        </CreateSubTaskUploadFileListItemStyled>
                      ))}
                    </CreateSubTaskUploadFileListWrapperStyled>
                  )}
                  {fileUploadedList && fileUploadedList.length !== 0 && (
                    <CreateSubTaskUploadFileListWrapperStyled>
                      {fileUploadedList.map(file => (
                        <CreateSubTaskUploadFileListItemStyled
                          key={file.file_id}>
                          <PaperClipOutlined
                            style={{ marginLeft: 5, marginRight: 8 }}
                          />
                          <span className="file-name">{file.file_name}</span>
                          <Tooltip title={'Xoá tập tin'}>
                            <DeleteOutlined
                              onClick={() =>
                                setFileUploadedList(
                                  fileUploadedList.filter(
                                    el => el.file_id !== file.file_id
                                  )
                                )
                              }
                            />
                          </Tooltip>
                        </CreateSubTaskUploadFileListItemStyled>
                      ))}
                    </CreateSubTaskUploadFileListWrapperStyled>
                  )}
                </Tabs.TabPane>
              </Tabs>
            </Col>
          </Row>

          <div className="custom-modal-footer">
            <Space>
              <Button
                danger
                className="custom-ant-button w-160"
                onClick={() => {
                  handleCancel()
                }}>
                Hủy
              </Button>
              <Button
                className="custom-ant-button w-160"
                type={'primary'}
                htmlType={'submit'}>
                Cập nhật
              </Button>
            </Space>
          </div>
        </Form>
        <SelectPeoplePopup
          id={'create-work-select-people-popup'}
          onlyOneUser={
            isElectronicWork
              ? selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
              : false
          }
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
          ignoreSelectList={disableList}
          ignorePopupType={ASSIGNEE_TYPE.HANDLER}
        />
        <SelectGroupPopup
          id={'create-work-select-group-popup'}
          isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          handleCancelSelectGroup={handleCancelSelectGroup}
          handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
        />
      </div>
    </Modal>
  )
}

export default inject(
  'selectPeopleStore',
  'fileStore',
  'workStore',
  'loadingAnimationStore',
  'infoOptionStore',
  'aclStore'
)(observer(WorkDetailUpdateModal))
